var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 11.5C8.15188 11.5 11.4998 8.15195 11.4998 4H12.4998C12.4998 8.15196 15.8475 11.4999 19.9994 11.4999V12.4999C15.8476 12.4999 12.4998 15.8479 12.4998 19.9999H11.4998C11.4998 15.848 8.15189 12.5 4 12.5V11.5ZM6.88598 12C9.26337 12.8546 11.1452 14.7364 11.9998 17.1138C12.8543 14.7364 14.7361 12.8545 17.1135 11.9999C14.7361 11.1453 12.8543 9.26347 11.9998 6.88607C11.1452 9.2635 9.26338 11.1454 6.88598 12Z","fill":"#ABE6C3"}));
}

Diamond.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Diamond;

Diamond.default = Diamond;
